import React from 'react'
import CircularProgress from 'material-ui/CircularProgress';
import Layout from './layout'

const Body = function(props) {
    return (
        <div id="main_content" className="spinner flex layout-column scrollable layout-align-center-center">
            <CircularProgress size={80} thickness={7} />
        </div>
    )
}

export default class extends React.Component {
    render() {
        return (
            <Layout title=""
                    showAppBarActions={false}
                    {...this.props}
                    errorMessage={this.props.errorMessage}
                    ready={this.props.errorMessage}
                    body={Body}>
            </Layout>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/spinner.js